import { Module, MutationTree } from "vuex"

const mutations: MutationTree<iSharedState.NotificationsState> = {
  setPage(state, page: iSharedNotifications.ListNotificationsResponseDto) {
    state.notifications = page.notifications
    state.total = page.total
    state.limit = page.limit
    state.offset = page.offset
    state.unreadCount = page.unreadCount
  },

  setUnreadCount(state, unreadCount: number) {
    state.unreadCount = Math.max(0, unreadCount)
  },

  addNotification(state, notification: iSharedNotifications.NotificationDto) {
    if (state.notifications.some((item) => item.uid === notification.uid)) return

    state.notifications = [notification, ...state.notifications].slice(0, state.limit)
    state.total += 1
    if (!notification.readAt) state.unreadCount += 1
  },

  markRead(state, notificationUid: string) {
    const notification = state.notifications.find((item) => item.uid === notificationUid)
    if (!notification || notification.readAt) return

    notification.readAt = new Date().toISOString()
    state.unreadCount = Math.max(0, state.unreadCount - 1)
  },

  markAllRead(state) {
    const readAt = new Date().toISOString()
    state.notifications.forEach((notification) => {
      if (!notification.readAt) notification.readAt = readAt
    })
    state.unreadCount = 0
  },

  clear(state) {
    state.notifications = []
    state.total = 0
    state.offset = 0
    state.unreadCount = 0
  }
}

export const notifications: Module<iSharedState.NotificationsState, iSharedState.RootState> = {
  namespaced: true,

  state: () => ({
    notifications: [],
    total: 0,
    limit: 25,
    offset: 0,
    unreadCount: 0
  }),

  mutations
}
